import { Component, ContentChildren, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UbigeoService } from 'src/app/service/ubigeo/ubigeo.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { DireccionRequest } from 'src/app/modal/usuario/direccion-request';
import { DireccionResponse } from 'src/app/modal/usuario/direccion-response';
import { DireccionUserResponse } from 'src/app/modal/usuario/direccion-user-response';
import { UbigeoResponse } from 'src/app/modal/ubigeo/ubbigeoResponse';
import { UbigeoBean } from 'src/app/modal/ubigeo/ubigeoBean';
import { UsuarioBeanResponse } from 'src/app/modal/usuario/usuario-bean-response';
import { RespuestaComun } from 'src/app/modal/maestras/respuesta-comun';
import { OrderRequest } from 'src/app/modal/procesapago/orderRequest';
import { OrderInternacionalRequest } from 'src/app/modal/procesapago/OrderInternacionalRequest';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { DetailBook } from '../../../modal/procesapago/detailBook';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { CarritoHeader } from 'src/app/modal/carrito/carrito-header';
import { CdkStep, CdkStepper } from '@angular/cdk/stepper';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { ProcesarPagoService } from 'src/app/service/procesarpago/procesar-pago.service';
import { ExternosService } from 'src/app/service/externos/externos.service';
import { PersonaBeanM,RequestCredenciales,RucEntidadBeanMResponse } from 'src/app/modal/externo/externo';
import { LibroDetalle } from 'src/app/modal/catalogo/libro-detalle';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SourvenirDetalleResponse } from 'src/app/modal/sourvenir/sourvenir-detalle-response';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { GeolocationService } from 'src/app/service/geolocation/geolocation.service';

@Component({
  selector: 'app-informacion-envio',
  templateUrl: './informacion-envio.component.html',
  styleUrls: ['./informacion-envio.component.scss']
})

export class InformacionEnvioComponent implements OnInit {

  constructor(private ubigeoService:UbigeoService,
              private usuarioService:UsuarioService,
              private maestrasService:MaestrasService,
              public router : Router,
              private carritoService:CarritoService,
              private procesarPagoService:ProcesarPagoService,
              private novedadesService:NovedadesService,
              private utilitarioService:UtilitarioService,
              private externosService:ExternosService,
              private geolocationService:GeolocationService) { }
  
  public stepOneForm: FormGroup;  
  public divAgregarDireccion:Boolean;

  public displayTipoEntrega:String;
  public displayEnvioInternacional:String;
  public displayTipoEntregaRadios:String;
  public displayBtnNacional:String;  
  public displayTipoComprobante:String;
  
  rdbTipoEntregaVal:String;
  rdbComprobante:String;
  orderRequest:OrderRequest = new OrderRequest();
  usuarioBeanResponse:UsuarioBeanResponse = new UsuarioBeanResponse();
  ubigeoBean:UbigeoBean[] = new Array<UbigeoBean>();
  carritoDetalle:CarritoHeader;

  public departamento: UbigeoResponse;
  public provincia: UbigeoResponse;
  public distritoResponse: UbigeoResponse;
  public listDestino: RespuestaComun;
  public listPais: RespuestaComun;

  flagTerminosCondiciones:boolean=false;
  flagPoliticaPrivacidad:boolean=false;
  mostrarModalTerminos:boolean=false;
  direccionUserResponse: DireccionUserResponse;
  tipoEntregaBean:RespuestaComun;

  txtIdentificador:String;
  cboDepartamentoVal:String;
  cboRegionModel:String;
  cboPaisModel:String;
  cboDistrito:String;
  cboProvincia:String;
  txtReferencia:String;  
  txtPerContact:String;
  txtDireccion:String;
  txtCelular:String;
  txtPersonaApellidoMaterno: String;
  txtPersonaApellidoPaterno: String;
  txtPersonaNombres: String;
  txtDireccionInternacional:String;
  rdbDireccionEnvio:String = "0";

  txtRucModel:String = "";
  txtRazonSocialModel:String = "";
  txtDNIModel:String = "";
  txtFullNameModel:String = "";
  txtDireccionFiscalModel:String = "";

  // Variables para dirección fiscal estructurada
  cboDepartamentoFiscal: String = "";
  cboProvinciaFiscal: String = "";
  cboDistritoFiscal: String = "";
  txtDireccionFiscalDetalle: String = "";
  provinciaFiscal: UbigeoResponse = new UbigeoResponse();
  distritoFiscalResponse: UbigeoResponse = new UbigeoResponse();

  flagBuscarDniVerificado:String = "0";
  flagBuscarRucVerificado:String = "0";
  isLoadingDni: boolean = false;
  isLoadingRuc: boolean = false;
  enableManualDniInput: boolean = false;
  enableManualRucInput: boolean = false;

  // Variables para manejo de extranjeros
  isPeruvian: boolean = true; // Por defecto peruano
  detectedCountryCode: string = 'PE';
  detectedCountryName: string = 'Perú';
  listTipoDocumentoExtranjero: RespuestaComun;
  cboTipoDocumentoExtranjero: String = "";
  txtNroDocumentoExtranjero: String = "";
  txtNombreCompletoExtranjero: String = "";
  cboPaisResidenciaExtranjero: String = "";
  txtDireccionExtranjero: String = "";

  // Validaciones de documento extranjero
  maxLengthDocExtranjero: number = 12;
  minLengthDocExtranjero: number = 6;
  soloDigitosDocExtranjero: boolean = false;
  placeholderDocExtranjero: string = "Ingrese su documento";
  errorMsgDocExtranjero: string = "";

  // Control de bloqueo del select de destino
  destinoBloqueado: boolean = false;

  precioTotal:number=0;
  cantidadTotal:number=0;

  SubTotalTemp = 0;
  IGVProducto = 0;
  IGVDelivery = 0;
  IGVTotal = 0;   



  
  headElements = ['Dirección de entrega','Nombre', 'Dirección',  'Eliminar'];

  @Input() cdkStepper : CdkStepper;
  @Input() cdkStepOne : CdkStep;
  
  @Output()
  enviarPadreEvent:EventEmitter<string> = new EventEmitter<string>();

  @Output()
  enviarOrderRequest:EventEmitter<OrderRequest> = new EventEmitter<OrderRequest>();

  @Output()
  abrirModalTerminosEvent:EventEmitter<void> = new EventEmitter<void>();

  @Output()
  cerrarModalTerminosEvent:EventEmitter<void> = new EventEmitter<void>();

  @Output()
  aceptarTerminosEvent:EventEmitter<void> = new EventEmitter<void>();

  get txtIdentificadorVal() {return this.stepOneForm.get('txtIdentificadorVal');}
  get cboDepartamentoValidar() {return this.stepOneForm.get('cboDepartamentoValidar');}
  get cboProvinciaValidar() {return this.stepOneForm.get('cboProvinciaValidar');}
  get txtReferenciaValidar() {return this.stepOneForm.get('txtReferenciaValidar');}
  get cboDistritoValidar() {return this.stepOneForm.get('cboDistritoValidar');}
  get txtPerContactValidar() {return this.stepOneForm.get('txtPerContactValidar');}
  get txtDireccionValidar() {return this.stepOneForm.get('txtDireccionValidar');}
  get txtCelularValidar() {return this.stepOneForm.get('txtCelularValidar');}

  ngOnInit(): void {

    this.cboRegionModel = "13"; //por defecto Nacional
    this.rdbTipoEntregaVal = "10"; //por defecto entrega a docmicilio
    this.displayBtnNacional = "block";
    this.displayTipoEntrega = "block";
    this.displayTipoEntregaRadios = "block";
    this.displayEnvioInternacional = "none";
    this.displayTipoComprobante = "block"; // Mostrar tipo comprobante por defecto (Nacional)
    this.rdbComprobante = "22"; //por defecto boleto
    this.cboDepartamentoVal = "";
    this.cboProvincia = "";
    this.cboDistrito = "";
    this.cboPaisModel = "";
    this.txtDireccionInternacional= "";
    this.divAgregarDireccion = true;
    this.cdkStepOne.completed = false; //no puede pasar al siguiente step

    this.provincia = new UbigeoResponse();
    this.distritoResponse = new UbigeoResponse();

    // Inicializar variables para dirección fiscal
    this.provinciaFiscal = new UbigeoResponse();
    this.distritoFiscalResponse = new UbigeoResponse();

    this.listarDireccion();
    this.obtenerDepartamento();
    this.listarTipoEntrega();
    this.obtenerDestino();
    this.obtenerPais();
    this.detectarPaisVisitante();
    this.obtenerTiposDocumentoExtranjero();

    this.stepOneForm = new FormGroup({
      txtIdentificadorVal: new FormControl('', Validators.required),
      cboDepartamentoValidar: new FormControl('', Validators.required),
      cboProvinciaValidar: new FormControl('', Validators.required),
      txtReferenciaValidar: new FormControl('', Validators.required),
      cboDistritoValidar: new FormControl('', Validators.required),
      txtPerContactValidar: new FormControl('', Validators.required),
      txtDireccionValidar: new FormControl('', Validators.required),
      txtCelularValidar: new FormControl('', Validators.required)
    });    

  }

  onEnviarEventoPadre(){
    this.enviarPadreEvent.emit("1");
  }

  ngAfterViewInit(){
    this.stepOneForm.clearValidators();
    // Los datos fiscales del usuario ahora se cargan en detectarPaisVisitante()
    // después de que la geolocalización se complete, para asegurar que isPeruvian
    // tenga el valor correcto antes de determinar qué formulario mostrar.
  }  

  onEnviarOrder(){
    
    let detailBookList = new Array<DetailBook>();    

    this.carritoDetalle = new CarritoHeader();
    this.carritoDetalle=this.carritoService.obtenerCarritoCompras()

    for (let i = 0; i < this.carritoDetalle.lista.length; i++) {
      let detailBook = new DetailBook();
      if(this.carritoDetalle.lista[i].tipoProducto=="1"){
        detailBook.bookId = this.carritoDetalle.lista[i].id;
        detailBook.productId = "0";
        detailBook.sizeId = this.carritoDetalle.lista[i].sizeID;
        detailBook.modalidadId = this.carritoDetalle.lista[i].modalidadId;
      }
      else if(this.carritoDetalle.lista[i].tipoProducto=="2"){
        detailBook.productId = this.carritoDetalle.lista[i].id;
        detailBook.bookId ="0";
        detailBook.sizeId = this.carritoDetalle.lista[i].sizeID;
        detailBook.modalidadId = "0";
      }
      //detailBook.bookId = this.carritoDetalle.lista[i].id;
      detailBook.quantity = this.carritoDetalle.lista[i].cantidad;      
     
      //detailBook.productId = this.carritoDetalle.lista[i].tipoProducto;
      detailBookList.push(detailBook);
    }

    this.orderRequest.detailBookAndProduct = detailBookList;

    this.orderRequest.addressId= this.rdbDireccionEnvio;
    this.orderRequest.clientId= this.usuarioService.obtenerIDSessionUsuario();    


    // console.log("OrdenCompra "+ this.orderRequest.detailBookAndProduct);


    this.usuarioService.obtenerUser(this.orderRequest.clientId).subscribe(data=>{

      this.usuarioBeanResponse = data;
      // console.log(this.usuarioBeanResponse);

      // Asignar dirección fiscal concatenada desde los campos estructurados
      this.orderRequest.fiscalAddress = this.obtenerDireccionFiscalConcatenada();
      // console.log("Dirección fiscal concatenada:", this.orderRequest.fiscalAddress);

      if(this.flagBuscarDniVerificado=="1"){ //obtiene datos del comprobante boleta

        // Si es EXTRANJERO, usar datos del formulario de extranjeros
        if (!this.isPeruvian) {
          const nombreCompleto = this.txtNombreCompletoExtranjero.toString().trim();
          const partes = nombreCompleto.split(' ');

          // Procesar nombre completo del extranjero
          if(partes.length >= 3){
            this.txtPersonaApellidoPaterno = partes[partes.length - 2];
            this.txtPersonaApellidoMaterno = partes[partes.length - 1];
            this.txtPersonaNombres = partes.slice(0, partes.length - 2).join(' ');
          } else if(partes.length === 2){
            this.txtPersonaNombres = partes[0];
            this.txtPersonaApellidoPaterno = partes[1];
            this.txtPersonaApellidoMaterno = "";
          } else if(partes.length === 1){
            this.txtPersonaNombres = partes[0];
            this.txtPersonaApellidoPaterno = "";
            this.txtPersonaApellidoMaterno = "";
          }

          // Para boleta de extranjero: usar datos del formulario extranjero
          this.orderRequest.fullName = nombreCompleto.toUpperCase();
          this.orderRequest.nroDocumento = this.txtNroDocumentoExtranjero;
          this.orderRequest.personaNombres = this.txtPersonaNombres;
          this.orderRequest.personaApellidoPaterno = this.txtPersonaApellidoPaterno;
          this.orderRequest.personaApellidoMaterno = this.txtPersonaApellidoMaterno;

          // Dirección fiscal para extranjeros: usar la dirección ingresada
          // Obtener el nombre del país seleccionado
          let nombrePais = "";
          if (this.listPais && this.listPais.response && this.listPais.response.list) {
            const paisEncontrado = this.listPais.response.list.find(p => p.masterId === this.cboPaisResidenciaExtranjero);
            if (paisEncontrado) {
              nombrePais = paisEncontrado.masterDescription;
            }
          }
          this.orderRequest.fiscalAddress = `${this.txtDireccionExtranjero.toString().trim().toUpperCase()}, ${nombrePais.toUpperCase()}`;

          // console.log("Datos de extranjero:");
          // console.log("Tipo documento:", this.cboTipoDocumentoExtranjero);
          // console.log("Nro documento:", this.txtNroDocumentoExtranjero);
          // console.log("Nombre completo:", nombreCompleto);
          // console.log("País residencia:", nombrePais);
          // console.log("Dirección:", this.txtDireccionExtranjero);

        } else {
          // Si es PERUANO y los datos fueron ingresados manualmente (enableManualDniInput), procesar txtFullNameModel
          if(this.enableManualDniInput && this.txtFullNameModel && this.txtFullNameModel.toString().trim() !== ""){
            const nombreCompleto = this.txtFullNameModel.toString().trim();
            const partes = nombreCompleto.split(' ');

            // Si hay al menos 3 partes: nombres, apellidoPaterno, apellidoMaterno
            if(partes.length >= 3){
              this.txtPersonaApellidoPaterno = partes[partes.length - 2];
              this.txtPersonaApellidoMaterno = partes[partes.length - 1];
              this.txtPersonaNombres = partes.slice(0, partes.length - 2).join(' ');
            }
            // Si hay 2 partes: nombres, apellidoPaterno
            else if(partes.length === 2){
              this.txtPersonaNombres = partes[0];
              this.txtPersonaApellidoPaterno = partes[1];
              this.txtPersonaApellidoMaterno = "";
            }
            // Si solo hay 1 parte: todo va a nombres
            else if(partes.length === 1){
              this.txtPersonaNombres = partes[0];
              this.txtPersonaApellidoPaterno = "";
              this.txtPersonaApellidoMaterno = "";
            }
          }

          // Para boleta de peruano: usar datos de DNI
          this.orderRequest.fullName= this.txtFullNameModel.toString().trim().toUpperCase();
          this.orderRequest.nroDocumento= this.txtDNIModel;
          this.orderRequest.personaNombres = this.txtPersonaNombres;
          this.orderRequest.personaApellidoPaterno = this.txtPersonaApellidoPaterno;
          this.orderRequest.personaApellidoMaterno = this.txtPersonaApellidoMaterno;
        }

      }
      else{//obtiene datos del usuario para factura

        // Para factura: usar datos de RUC
        this.orderRequest.razonSocial= this.txtRazonSocialModel.toString().trim().toUpperCase();
        this.orderRequest.ruc= this.txtRucModel;

      }
      this.orderRequest.igvCost= "";
      this.orderRequest.shippingCost= "";
      this.orderRequest.subtotalCost= "";
      this.orderRequest.totalCost= "";
      this.orderRequest.typeDeliveryId= this.rdbTipoEntregaVal; //domicilio
      this.orderRequest.typeRegionId= "13"; //envio nacional
      this.orderRequest.typeShippingId= "12"; // peru
      this.orderRequest.typeVoucherId= this.rdbComprobante;

      // console.log("Datos de la orden antes de enviar:");
      // console.log("fullName:", this.orderRequest.fullName);
      // console.log("personaNombres:", this.orderRequest.personaNombres);
      // console.log("personaApellidoPaterno:", this.orderRequest.personaApellidoPaterno);
      // console.log("personaApellidoMaterno:", this.orderRequest.personaApellidoMaterno);
      // console.log("enableManualDniInput:", this.enableManualDniInput);
      // console.log("flagBuscarDniVerificado:", this.flagBuscarDniVerificado);
      // console.log("Order completa:", this.orderRequest);
      this.enviarOrderRequest.emit(this.orderRequest);

    })

  }

  onchangeDireccion(idDireccion:String){

    if (idDireccion=="11"){ //si no es envio a direccion se oculta seccion registrar direccion
       this.displayTipoEntrega = "block";
    }else{this.displayTipoEntrega = "none";}
    
    //refresca datos totales del padre component
    this.onEnviarEventoPadre();

  }

  onchangeDestino(){

    // Ambos casos (Nacional e Internacional) muestran el mismo formulario
    // Solo cambia el valor del destino, todo se envía por correo
    this.displayTipoEntrega = "block";
    this.displayEnvioInternacional = "none"; // Siempre oculto
    this.displayTipoEntregaRadios = "block";
    this.displayBtnNacional = "block";
    this.displayTipoComprobante = "block";

    //refresca datos totales del padre component
    //this.onEnviarEventoPadre();

  }

  onchangeComprobante(){

    if (this.rdbComprobante=="22"){ //boleta
      //console.log(this.rdbComprobante);
      (<HTMLInputElement>document.getElementById("txtRuc")).disabled = true;
      (<HTMLInputElement>document.getElementById("txtDNI")).disabled = false;

      // Limpiar datos de factura
      this.txtRucModel = "";
      this.txtRazonSocialModel = "";
      this.flagBuscarRucVerificado = "0";
      this.enableManualRucInput = false;

      // Recargar datos de boleta del usuario si está logueado
      this.recargarDatosBoletaUsuario();

    }else{ //factura
      //console.log(this.rdbComprobante);
      (<HTMLInputElement>document.getElementById("txtRuc")).disabled = false;
      (<HTMLInputElement>document.getElementById("txtDNI")).disabled = true;

      // Limpiar datos de boleta
      this.txtDNIModel = "";
      this.txtFullNameModel = "";
      this.flagBuscarDniVerificado = "0";
      this.enableManualDniInput = false;

      // Recargar datos de factura del usuario si está logueado
      this.recargarDatosFacturaUsuario();

    }

  }

  /**
   * Recarga los datos de boleta (DNI y nombre) del usuario si está logueado
   */
  recargarDatosBoletaUsuario(): void {
    const userId = this.usuarioService.obtenerIDSessionUsuario();

    // Solo cargar si hay un usuario logueado
    if(!userId || userId === "" || userId === null) {
      return;
    }

    // Obtener datos del usuario
    this.usuarioService.obtenerUser(userId).subscribe(data => {
      if(data.response.list && data.response.list.length > 0) {
        const usuario = data.response.list[0];

        // Solo precargar si tiene DNI
        if(usuario.typeDocumentId === "1" && usuario.document && usuario.document.length === 8) {
          this.txtDNIModel = usuario.document;

          // Formato: Apellidos, Nombres (en mayúsculas)
          const nombreCompleto = `${usuario.surname || ''} ${usuario.name || ''}`.trim().toUpperCase();
          if(nombreCompleto) {
            this.txtFullNameModel = nombreCompleto;
          }

          this.flagBuscarDniVerificado = "1";
          this.enableManualDniInput = false;

          // console.log('✅ Datos de boleta recargados');
        }
      }
    });
  }

  /**
   * Recarga los datos de factura (RUC y razón social) del usuario si está logueado
   */
  recargarDatosFacturaUsuario(): void {
    const userId = this.usuarioService.obtenerIDSessionUsuario();

    // Solo cargar si hay un usuario logueado
    if(!userId || userId === "" || userId === null) {
      return;
    }

    // Obtener datos del usuario
    this.usuarioService.obtenerUser(userId).subscribe(data => {
      if(data.response.list && data.response.list.length > 0) {
        const usuario = data.response.list[0];

        // Solo precargar si tiene RUC
        if(usuario.typeDocumentId === "4" && usuario.document && usuario.document.length === 11) {
          this.txtRucModel = usuario.document;

          const razonSocial = `${usuario.name || ''} ${usuario.surname || ''}`.trim();
          if(razonSocial) {
            this.txtRazonSocialModel = razonSocial;
          }

          this.flagBuscarRucVerificado = "1";
          this.enableManualRucInput = false;

          // console.log('✅ Datos de factura recargados');
        }
      }
    });
  }

  obtenerDepartamento(){
    this.utilitarioService.loading = true;
    this.departamento = new UbigeoResponse();
    this.ubigeoService.obtenerDepartamento().subscribe(data=>{
      this.departamento = data;
      this.utilitarioService.loading = false;
    })
  }

  /**
   * Obtiene las provincias para la dirección fiscal
   */
  obtenerProvinciaFiscal(codDepartamento: String){
    this.provinciaFiscal = new UbigeoResponse();
    this.distritoFiscalResponse = new UbigeoResponse();
    this.cboProvinciaFiscal = "";
    this.cboDistritoFiscal = "";

    if(!codDepartamento) return;

    this.ubigeoService.obtenerProvincia(codDepartamento).subscribe(data =>{
      this.provinciaFiscal = data;
    })
  }

  /**
   * Obtiene los distritos para la dirección fiscal
   */
  obtenerDistritosFiscal(codDepartamento: String, codProvincia: String){
    this.distritoFiscalResponse = new UbigeoResponse();
    this.cboDistritoFiscal = "";

    if(!codDepartamento || !codProvincia) return;

    this.ubigeoService.obtenerDistrito(codDepartamento, codProvincia).subscribe(data =>{
      this.distritoFiscalResponse = data;
    })
  }

  /**
   * Concatena la dirección fiscal completa a partir de los campos estructurados
   * Formato: Dirección, Distrito, Provincia, Departamento (todo en MAYÚSCULAS)
   */
  obtenerDireccionFiscalConcatenada(): string {
    const partes: string[] = [];

    // Dirección detalle
    if(this.txtDireccionFiscalDetalle && this.txtDireccionFiscalDetalle.toString().trim() !== "") {
      partes.push(this.txtDireccionFiscalDetalle.toString().trim().toUpperCase());
    }

    // Distrito
    if(this.cboDistritoFiscal) {
      const distrito = this.distritoFiscalResponse.response.list.find(d => d.codeDistrict === this.cboDistritoFiscal);
      if(distrito) {
        partes.push(distrito.name.toUpperCase());
      }
    }

    // Provincia
    if(this.cboProvinciaFiscal) {
      const provincia = this.provinciaFiscal.response.list.find(p => p.codeProvince === this.cboProvinciaFiscal);
      if(provincia) {
        partes.push(provincia.name.toUpperCase());
      }
    }

    // Departamento
    if(this.cboDepartamentoFiscal) {
      const departamento = this.departamento.response.list.find(d => d.codeDepartment === this.cboDepartamentoFiscal);
      if(departamento) {
        partes.push(departamento.name.toUpperCase());
      }
    }

    return partes.join(", ");
  }

  /**
   * Carga los datos de dirección fiscal del usuario logueado
   * Usa la dirección residencial del usuario como valores predeterminados
   * También precarga DNI/RUC y nombre/razón social según el tipo de documento
   * Preselecciona Boleta o Factura automáticamente
   */
  cargarDatosFiscalesUsuario(): void {
    const userId = this.usuarioService.obtenerIDSessionUsuario();

    // Solo cargar si hay un usuario logueado
    if(!userId || userId === "" || userId === null) {
      return;
    }

    // Obtener datos del usuario
    this.usuarioService.obtenerUser(userId).subscribe(data => {
      this.usuarioBeanResponse = data;

      if(this.usuarioBeanResponse.response.list && this.usuarioBeanResponse.response.list.length > 0) {
        const usuario = this.usuarioBeanResponse.response.list[0];

        // Precargar datos según tipo de documento
        // Tipo 1 = DNI (Boleta)
        if(usuario.typeDocumentId === "1" && usuario.document && usuario.document.length === 8) {
          // console.log('✅ Usuario tiene DNI, precargando datos de BOLETA');
          // console.log('DNI:', usuario.document);
          // console.log('Nombre:', usuario.name, 'Apellidos:', usuario.surname);
          // console.log('isPeruvian (geolocalización):', this.isPeruvian);

          // Si el usuario fue detectado como EXTRANJERO por geolocalización,
          // autocompletar también el formulario de extranjero con sus datos
          if (!this.isPeruvian) {
            // console.log('👤 Usuario con DNI pero detectado como extranjero - completando formulario extranjero');

            // Autocompletar nombre en formulario de extranjero
            const nombreCompletoExtranjero = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
            if (nombreCompletoExtranjero) {
              this.txtNombreCompletoExtranjero = nombreCompletoExtranjero;
              // console.log('✅ Nombre extranjero autocompletado:', nombreCompletoExtranjero);
            }

            // Preseleccionar país basado en geolocalización
            this.preseleccionarPaisResidencia();

            // Marcar boleta como comprobante
            this.rdbComprobante = "22";
            this.flagBuscarDniVerificado = "1";
          } else {
            // Usuario PERUANO - usar formulario normal de DNI
            // Preseleccionar Boleta
            this.rdbComprobante = "22";

            // Cargar DNI
            this.txtDNIModel = usuario.document;

            // Construir nombre completo - Formato: Apellidos Nombres (en mayúsculas)
            const nombreCompleto = `${usuario.surname || ''} ${usuario.name || ''}`.trim().toUpperCase();
            if(nombreCompleto) {
              this.txtFullNameModel = nombreCompleto;
            }

            // Marcar como verificado para que no requiera búsqueda adicional
            this.flagBuscarDniVerificado = "1";
            this.enableManualDniInput = false;

            // console.log('✅ Valores asignados:');
            // console.log('rdbComprobante:', this.rdbComprobante);
            // console.log('txtDNIModel:', this.txtDNIModel);
            // console.log('txtFullNameModel:', this.txtFullNameModel);

            // Ejecutar cambio de comprobante para habilitar/deshabilitar campos
            this.onchangeComprobante();
          }
        }
        // Tipo 4 = RUC (Factura)
        else if(usuario.typeDocumentId === "4" && usuario.document && usuario.document.length === 11) {
          // console.log('✅ Usuario tiene RUC, precargando datos de FACTURA');
          // console.log('RUC:', usuario.document);
          // console.log('Razón Social:', usuario.name, usuario.surname);
          // console.log('isPeruvian (geolocalización):', this.isPeruvian);

          // Si el usuario fue detectado como EXTRANJERO por geolocalización,
          // autocompletar el formulario de extranjero con sus datos
          if (!this.isPeruvian) {
            // console.log('👤 Usuario con RUC pero detectado como extranjero - completando formulario extranjero');

            // Autocompletar nombre en formulario de extranjero
            const nombreCompletoExtranjero = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
            if (nombreCompletoExtranjero) {
              this.txtNombreCompletoExtranjero = nombreCompletoExtranjero;
              // console.log('✅ Nombre extranjero autocompletado:', nombreCompletoExtranjero);
            }

            // Preseleccionar país basado en geolocalización
            this.preseleccionarPaisResidencia();

            // Marcar boleta como comprobante (extranjeros solo boleta)
            this.rdbComprobante = "22";
            this.flagBuscarDniVerificado = "1";
          } else {
            // Usuario PERUANO - usar formulario normal de RUC
            // Preseleccionar Factura
            this.rdbComprobante = "23";

            // Cargar RUC
            this.txtRucModel = usuario.document;

            // Construir razón social (puede ser nombre completo o razón social)
            const razonSocial = `${usuario.name || ''} ${usuario.surname || ''}`.trim();
            if(razonSocial) {
              this.txtRazonSocialModel = razonSocial;
            }

            // Marcar como verificado para que no requiera búsqueda adicional
            this.flagBuscarRucVerificado = "1";
            this.enableManualRucInput = false;

            // console.log('✅ Valores asignados:');
            // console.log('rdbComprobante:', this.rdbComprobante);
            // console.log('txtRucModel:', this.txtRucModel);
            // console.log('txtRazonSocialModel:', this.txtRazonSocialModel);

            // Ejecutar cambio de comprobante para habilitar/deshabilitar campos
            this.onchangeComprobante();
          }
        }
        // Tipo 2 = Carnet de Extranjería, Tipo 3 = Pasaporte (Extranjeros)
        else if((usuario.typeDocumentId === "2" || usuario.typeDocumentId === "3") && usuario.document) {
          // console.log('✅ Usuario tiene documento de extranjero, precargando datos');
          // console.log('Tipo documento:', usuario.typeDocumentId);
          // console.log('Documento:', usuario.document);
          // console.log('Nombre:', usuario.name, 'Apellidos:', usuario.surname);

          // Marcar como extranjero
          this.isPeruvian = false;

          // Preseleccionar tipo de documento
          this.cboTipoDocumentoExtranjero = usuario.typeDocumentId;

          // Cargar número de documento
          this.txtNroDocumentoExtranjero = usuario.document;

          // Construir nombre completo - Formato: Nombres Apellidos (en mayúsculas)
          const nombreCompleto = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
          if(nombreCompleto) {
            this.txtNombreCompletoExtranjero = nombreCompleto;
          }

          // Preseleccionar Boleta (único comprobante para extranjeros)
          this.rdbComprobante = "22";
          this.flagBuscarDniVerificado = "1";

          // console.log('✅ Valores de extranjero asignados:');
          // console.log('cboTipoDocumentoExtranjero:', this.cboTipoDocumentoExtranjero);
          // console.log('txtNroDocumentoExtranjero:', this.txtNroDocumentoExtranjero);
          // console.log('txtNombreCompletoExtranjero:', this.txtNombreCompletoExtranjero);

          // Preseleccionar país si la geolocalización ya lo detectó
          if (!this.cboPaisResidenciaExtranjero || this.cboPaisResidenciaExtranjero === "") {
            this.preseleccionarPaisResidencia();
          }
        }
        else {
          // console.log('ℹ️ Usuario tiene otro tipo de documento o datos incompletos');
          // console.log('typeDocumentId:', usuario.typeDocumentId);
          // console.log('document:', usuario.document);
          // console.log('document.length:', usuario.document?.length);

          // Si el usuario fue detectado como extranjero por geolocalización,
          // autocompletar el nombre aunque no tenga documento tipo 2 o 3
          if (!this.isPeruvian) {
            const nombreCompleto = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
            if (nombreCompleto) {
              this.txtNombreCompletoExtranjero = nombreCompleto;
              // console.log('✅ Nombre de extranjero autocompletado:', nombreCompleto);
            }
            // Preseleccionar país basado en geolocalización
            this.preseleccionarPaisResidencia();
          }
        }

        // Precargar departamento fiscal (solo para peruanos)
        if(usuario.department) {
          this.cboDepartamentoFiscal = usuario.department;

          // Cargar provincias del departamento
          this.obtenerProvinciaFiscal(usuario.department);

          // Si tiene provincia, cargarla
          if(usuario.province) {
            // Usar setTimeout para esperar a que se carguen las provincias
            setTimeout(() => {
              this.cboProvinciaFiscal = usuario.province;

              // Cargar distritos de la provincia
              this.obtenerDistritosFiscal(usuario.department, usuario.province);

              // Si tiene distrito, cargarlo
              if(usuario.district) {
                // Usar setTimeout para esperar a que se carguen los distritos
                setTimeout(() => {
                  this.cboDistritoFiscal = usuario.district;
                }, 300);
              }
            }, 300);
          }
        }
      }
    });
  }

  obtenerDestino(){
    this.utilitarioService.loading = true;
    this.listDestino = new RespuestaComun();
    this.maestrasService.obtenerMaestra("TIPO_REGION").subscribe(data=>{
      this.listDestino = data;
      //console.log(data);
      this.utilitarioService.loading = false;
    });
  }

  obtenerPais(){

    this.utilitarioService.loading = true;
    this.listPais = new RespuestaComun();
    this.maestrasService.obtenerMaestra("TIPO_PAIS").subscribe(data=>{
      this.listPais = data;
      //console.log(data);
      this.utilitarioService.loading = false;
    });

  }

  /**
   * Detecta el país del visitante usando geolocalización por IP.
   * Si el usuario está logueado, también verifica su tipo de documento:
   * - Solo es "Peruano" si está en Perú Y tiene DNI
   * - Es "Extranjero" si está fuera de Perú O tiene Carnet de Extranjería/Pasaporte
   *
   * También configura el tipo de destino (Nacional/Internacional) automáticamente.
   */
  detectarPaisVisitante(): void {
    this.geolocationService.getGeoLocation().subscribe(geoData => {
      this.detectedCountryCode = geoData.countryCode;
      this.detectedCountryName = geoData.countryName;

      const geoEsPeruano = geoData.countryCode === 'PE';
      // console.log('📍 País detectado por IP:', this.detectedCountryName, '(' + this.detectedCountryCode + ')');
      // console.log('📍 ¿Geolocalización en Perú?:', geoEsPeruano);

      // Verificar si el usuario está logueado
      const userId = this.usuarioService.obtenerIDSessionUsuario();

      if (userId && userId !== "" && userId !== null) {
        // Usuario logueado: verificar tipo de documento
        this.usuarioService.obtenerUser(userId).subscribe(data => {
          if (data.response.list && data.response.list.length > 0) {
            const usuario = data.response.list[0];
            const tipoDocumento = usuario.typeDocumentId;

            // console.log('👤 Usuario logueado - Tipo documento:', tipoDocumento);

            // Determinar si es peruano según geolocalización Y tipo de documento
            // Tipo 1 = DNI (Peruano)
            // Tipo 2 = Carnet de Extranjería (Extranjero)
            // Tipo 3 = Pasaporte (Extranjero)
            this.isPeruvian = this.determinarSiEsPeruano(geoEsPeruano, tipoDocumento);

            // console.log('🎯 Resultado final - ¿Es Peruano?:', this.isPeruvian);

            // Configurar UI según el resultado
            this.configurarUISegunNacionalidad();

            // Cargar datos fiscales del usuario
            this.cargarDatosFiscalesUsuarioInterno(usuario);
          } else {
            // No se encontró usuario, usar solo geolocalización
            this.isPeruvian = geoEsPeruano;
            this.configurarUISegunNacionalidad();
            this.cargarDatosFiscalesUsuario();
          }
        }, error => {
          console.error('Error al obtener usuario:', error);
          // En caso de error, usar solo geolocalización
          this.isPeruvian = geoEsPeruano;
          this.configurarUISegunNacionalidad();
        });
      } else {
        // Usuario NO logueado: usar solo geolocalización
        // console.log('👤 Usuario NO logueado - usando solo geolocalización');
        this.isPeruvian = geoEsPeruano;
        this.configurarUISegunNacionalidad();
      }
    });
  }

  /**
   * Determina si el usuario debe ser tratado como peruano.
   * Solo es peruano si:
   * - Está geolocalizado en Perú Y
   * - Tiene DNI como tipo de documento (typeDocumentId = 1)
   *
   * Es extranjero si:
   * - Está fuera de Perú, O
   * - Tiene Carnet de Extranjería (2) o Pasaporte (3)
   *
   * @param geoEsPeruano true si la geolocalización indica Perú
   * @param tipoDocumento ID del tipo de documento del usuario
   * @returns true si debe tratarse como peruano, false si extranjero
   */
  determinarSiEsPeruano(geoEsPeruano: boolean, tipoDocumento: string): boolean {
    // Si la geolocalización NO es Perú, siempre es extranjero
    if (!geoEsPeruano) {
      // console.log('🌍 Geolocalización fuera de Perú → Extranjero');
      return false;
    }

    // Geolocalización es Perú, verificar tipo de documento
    // Tipo 1 = DNI → Peruano
    // Tipo 2 = Carnet de Extranjería → Extranjero
    // Tipo 3 = Pasaporte → Extranjero
    if (tipoDocumento === "1") {
      // console.log('🇵🇪 Geolocalización en Perú + DNI → Peruano');
      return true;
    } else if (tipoDocumento === "2" || tipoDocumento === "3") {
      // console.log('🌍 Geolocalización en Perú + Carnet/Pasaporte → Extranjero');
      return false;
    }

    // Si no tiene tipo de documento definido, usar geolocalización
    // console.log('❓ Tipo documento no definido, usando geolocalización');
    return geoEsPeruano;
  }

  /**
   * Configura la UI según si el usuario es peruano o extranjero.
   * Establece el destino (Nacional/Internacional) y actualiza los formularios.
   */
  configurarUISegunNacionalidad(): void {
    // Configurar destino según nacionalidad
    if (this.isPeruvian) {
      this.cboRegionModel = "13"; // Nacional
      // console.log('✅ Destino configurado: NACIONAL (Peruano)');
    } else {
      this.cboRegionModel = "14"; // Internacional
      // console.log('✅ Destino configurado: INTERNACIONAL (Extranjero)');
    }
    this.destinoBloqueado = true; // Bloquear el select
    this.onchangeDestino(); // Actualizar la UI según el destino

    // Si es extranjero, preseleccionar su país de residencia
    if (!this.isPeruvian && this.listPais && this.listPais.response && this.listPais.response.list) {
      this.preseleccionarPaisResidencia();
    }
  }

  /**
   * Versión interna de cargarDatosFiscalesUsuario que recibe el usuario ya cargado.
   * Evita hacer una segunda llamada al servidor.
   */
  cargarDatosFiscalesUsuarioInterno(usuario: any): void {
    if (!usuario) return;

    // Guardar respuesta para uso posterior
    this.usuarioBeanResponse = { response: { list: [usuario] } } as any;

    // Precargar datos según tipo de documento
    // Tipo 1 = DNI (Boleta)
    if (usuario.typeDocumentId === "1" && usuario.document && usuario.document.length === 8) {
      // console.log('✅ Usuario tiene DNI, precargando datos de BOLETA');

      if (!this.isPeruvian) {
        // Usuario con DNI pero tratado como extranjero (por geolocalización fuera de Perú)
        // console.log('👤 Usuario con DNI pero es extranjero - completando formulario extranjero');
        const nombreCompletoExtranjero = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
        if (nombreCompletoExtranjero) {
          this.txtNombreCompletoExtranjero = nombreCompletoExtranjero;
        }
        this.preseleccionarPaisResidencia();
        this.rdbComprobante = "22";
        this.flagBuscarDniVerificado = "1";
      } else {
        // Usuario PERUANO - usar formulario normal de DNI
        this.rdbComprobante = "22";
        this.txtDNIModel = usuario.document;
        const nombreCompleto = `${usuario.surname || ''} ${usuario.name || ''}`.trim().toUpperCase();
        if (nombreCompleto) {
          this.txtFullNameModel = nombreCompleto;
        }
        this.flagBuscarDniVerificado = "1";
        this.enableManualDniInput = false;
        this.onchangeComprobante();
      }
    }
    // Tipo 2 = Carnet de Extranjería
    else if (usuario.typeDocumentId === "2" && usuario.document) {
      // console.log('✅ Usuario tiene Carnet de Extranjería - tratado como EXTRANJERO');
      this.rdbComprobante = "22"; // Boleta para extranjeros

      // Precargar datos en formulario de extranjero
      this.cboTipoDocumentoExtranjero = "2"; // Carnet de Extranjería
      this.txtNroDocumentoExtranjero = usuario.document;
      const nombreCompleto = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
      if (nombreCompleto) {
        this.txtNombreCompletoExtranjero = nombreCompleto;
      }
      this.preseleccionarPaisResidencia();
      this.flagBuscarDniVerificado = "1";

      // Configurar validación para Carnet de Extranjería
      this.onChangeTipoDocExtranjero("2");
    }
    // Tipo 3 = Pasaporte
    else if (usuario.typeDocumentId === "3" && usuario.document) {
      // console.log('✅ Usuario tiene Pasaporte - tratado como EXTRANJERO');
      this.rdbComprobante = "22"; // Boleta para extranjeros

      // Precargar datos en formulario de extranjero
      this.cboTipoDocumentoExtranjero = "3"; // Pasaporte
      this.txtNroDocumentoExtranjero = usuario.document;
      const nombreCompleto = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
      if (nombreCompleto) {
        this.txtNombreCompletoExtranjero = nombreCompleto;
      }
      this.preseleccionarPaisResidencia();
      this.flagBuscarDniVerificado = "1";

      // Configurar validación para Pasaporte
      this.onChangeTipoDocExtranjero("3");
    }
    // Tipo 4 = RUC (Factura) - Solo para peruanos
    else if (usuario.typeDocumentId === "4" && usuario.document && usuario.document.length === 11) {
      // console.log('✅ Usuario tiene RUC, precargando datos de FACTURA');

      if (!this.isPeruvian) {
        // Usuario con RUC pero detectado como extranjero
        // console.log('👤 Usuario con RUC pero es extranjero - completando formulario extranjero');
        const nombreCompletoExtranjero = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
        if (nombreCompletoExtranjero) {
          this.txtNombreCompletoExtranjero = nombreCompletoExtranjero;
        }
        this.preseleccionarPaisResidencia();
        this.rdbComprobante = "22";
        this.flagBuscarDniVerificado = "1";
      } else {
        // Usuario PERUANO con RUC
        this.rdbComprobante = "23";
        this.txtRucModel = usuario.document;
        const razonSocial = `${usuario.name || ''} ${usuario.surname || ''}`.trim().toUpperCase();
        if (razonSocial) {
          this.txtRazonSocialModel = razonSocial;
        }
        this.flagBuscarRucVerificado = "1";
        this.enableManualRucInput = false;
        this.onchangeComprobante();
      }
    }

    // Precargar dirección fiscal si existe (solo para peruanos)
    if (this.isPeruvian) {
      this.precargarDireccionFiscal(usuario);
    }
  }

  /**
   * Precarga la dirección fiscal del usuario (departamento, provincia, distrito).
   * Solo aplica para usuarios peruanos.
   */
  precargarDireccionFiscal(usuario: any): void {
    if (!usuario || !usuario.department) return;

    this.cboDepartamentoFiscal = usuario.department;

    // Cargar provincias del departamento
    this.obtenerProvinciaFiscal(usuario.department);

    // Si tiene provincia, cargarla
    if (usuario.province) {
      // Usar setTimeout para esperar a que se carguen las provincias
      setTimeout(() => {
        this.cboProvinciaFiscal = usuario.province;

        // Cargar distritos de la provincia
        this.obtenerDistritosFiscal(usuario.department, usuario.province);

        // Si tiene distrito, cargarlo
        if (usuario.district) {
          // Usar setTimeout para esperar a que se carguen los distritos
          setTimeout(() => {
            this.cboDistritoFiscal = usuario.district;
          }, 300);
        }
      }, 300);
    }

    // Precargar dirección fiscal detallada si existe
    if (usuario.address) {
      this.txtDireccionFiscalDetalle = usuario.address;
    }
  }

  /**
   * Normaliza un texto removiendo tildes/acentos y convirtiéndolo a minúsculas.
   * Ejemplo: "México" -> "mexico", "PERÚ" -> "peru"
   */
  normalizarTexto(texto: string): string {
    if (!texto) return '';
    return texto
      .toLowerCase()
      .normalize('NFD') // Descompone caracteres acentuados (é -> e + ´)
      .replace(/[\u0300-\u036f]/g, '') // Remueve los diacríticos
      .trim();
  }

  /**
   * Mapeo de nombres de países en inglés a español.
   * Usado para traducir el nombre detectado por geolocalización al nombre en BD.
   */
  private paisesInglesEspanol: { [key: string]: string } = {
    'united states': 'estados unidos',
    'usa': 'estados unidos',
    'united states of america': 'estados unidos',
    'mexico': 'mexico',
    'brazil': 'brasil',
    'spain': 'espana',
    'france': 'francia',
    'germany': 'alemania',
    'italy': 'italia',
    'united kingdom': 'reino unido',
    'uk': 'reino unido',
    'england': 'reino unido',
    'canada': 'canada',
    'argentina': 'argentina',
    'chile': 'chile',
    'colombia': 'colombia',
    'peru': 'peru',
    'venezuela': 'venezuela',
    'ecuador': 'ecuador',
    'bolivia': 'bolivia',
    'paraguay': 'paraguay',
    'uruguay': 'uruguay',
    'costa rica': 'costa rica',
    'panama': 'panama',
    'guatemala': 'guatemala',
    'cuba': 'cuba',
    'dominican republic': 'republica dominicana',
    'puerto rico': 'puerto rico',
    'el salvador': 'el salvador',
    'honduras': 'honduras',
    'nicaragua': 'nicaragua',
    'japan': 'japon',
    'china': 'china',
    'south korea': 'corea del sur',
    'india': 'india',
    'australia': 'australia',
    'new zealand': 'nueva zelanda',
    'netherlands': 'paises bajos',
    'belgium': 'belgica',
    'switzerland': 'suiza',
    'austria': 'austria',
    'portugal': 'portugal',
    'poland': 'polonia',
    'russia': 'rusia',
    'sweden': 'suecia',
    'norway': 'noruega',
    'denmark': 'dinamarca',
    'finland': 'finlandia',
    'ireland': 'irlanda',
    'greece': 'grecia',
    'turkey': 'turquia',
    'israel': 'israel',
    'south africa': 'sudafrica',
    'egypt': 'egipto'
  };

  /**
   * Traduce el nombre de un país de inglés a español si existe en el mapeo.
   */
  traducirPaisAEspanol(nombreIngles: string): string {
    const nombreNormalizado = this.normalizarTexto(nombreIngles);
    return this.paisesInglesEspanol[nombreNormalizado] || nombreNormalizado;
  }

  /**
   * Preselecciona el país de residencia basándose en la geolocalización.
   * Busca en la lista de países usando el nombre del país detectado.
   * Maneja correctamente:
   * - Tildes (México vs MEXICO, Perú vs PERU)
   * - Nombres en inglés vs español (United States vs ESTADOS UNIDOS)
   */
  preseleccionarPaisResidencia(): void {
    if (!this.listPais || !this.listPais.response || !this.listPais.response.list) {
      // Si la lista aún no está cargada, esperar un poco y reintentar
      setTimeout(() => this.preseleccionarPaisResidencia(), 500);
      return;
    }

    // Normalizar el nombre detectado (sin tildes, minúsculas)
    const nombreDetectadoNorm = this.normalizarTexto(this.detectedCountryName);

    // Traducir de inglés a español si es necesario
    const nombreTraducido = this.traducirPaisAEspanol(this.detectedCountryName);

    // console.log('Buscando país:', this.detectedCountryName);
    // console.log('  -> normalizado:', nombreDetectadoNorm);
    // console.log('  -> traducido:', nombreTraducido);

    // Buscar el país en la lista por nombre (comparación sin tildes)
    const paisEncontrado = this.listPais.response.list.find(pais => {
      const nombrePaisNorm = this.normalizarTexto(pais.masterDescription);

      // Comparación con nombre original normalizado
      if (nombrePaisNorm === nombreDetectadoNorm ||
          nombrePaisNorm.includes(nombreDetectadoNorm) ||
          nombreDetectadoNorm.includes(nombrePaisNorm)) {
        return true;
      }

      // Comparación con nombre traducido al español
      if (nombrePaisNorm === nombreTraducido ||
          nombrePaisNorm.includes(nombreTraducido) ||
          nombreTraducido.includes(nombrePaisNorm)) {
        return true;
      }

      return false;
    });

    if (paisEncontrado) {
      this.cboPaisResidenciaExtranjero = paisEncontrado.masterId;
      // console.log('✅ País preseleccionado:', paisEncontrado.masterDescription, '(ID:', paisEncontrado.masterId, ')');
    } else {
      // console.log('⚠️ No se encontró coincidencia para:', this.detectedCountryName);
      // console.log('  Normalizado:', nombreDetectadoNorm, '| Traducido:', nombreTraducido);
      // Listar algunos países disponibles para debug
      // console.log('Países disponibles (primeros 10):', this.listPais.response.list.slice(0, 10).map(p => p.masterDescription));
    }
  }

  /**
   * Obtiene la lista de tipos de documento para extranjeros.
   * Filtra solo Pasaporte y Carnet de Extranjería.
   */
  obtenerTiposDocumentoExtranjero(): void {
    this.listTipoDocumentoExtranjero = new RespuestaComun();
    this.maestrasService.obtenerMaestra("TIPO_DOCUMENTO").subscribe(data => {
      // Filtrar solo los tipos de documento para extranjeros (2=CE, 3=Pasaporte)
      if (data && data.response && data.response.list) {
        const documentosExtranjeros = data.response.list.filter(doc =>
          doc.masterId === "2" || doc.masterId === "3"
        );
        // Asignar la data completa y luego modificar la lista
        this.listTipoDocumentoExtranjero = data;
        this.listTipoDocumentoExtranjero.response.list = documentosExtranjeros as any;
        // console.log('Tipos de documento para extranjeros:', this.listTipoDocumentoExtranjero.response.list);
      }
    });
  }

  /**
   * Maneja el cambio de tipo de documento para extranjeros.
   * Ajusta la validación según el tipo seleccionado:
   * - Carnet de Extranjería (2): 9 dígitos numéricos
   * - Pasaporte (3): 6-12 caracteres alfanuméricos (letras y números)
   */
  onChangeTipoDocExtranjero(tipoDocId: String): void {
    this.txtNroDocumentoExtranjero = "";
    this.errorMsgDocExtranjero = "";

    switch(tipoDocId) {
      case "2": // Carnet de Extranjería
        this.maxLengthDocExtranjero = 9;
        this.minLengthDocExtranjero = 9;
        this.soloDigitosDocExtranjero = true;
        this.placeholderDocExtranjero = "Ingrese su documento";
        break;
      case "3": // Pasaporte
        this.maxLengthDocExtranjero = 12;
        this.minLengthDocExtranjero = 6;
        this.soloDigitosDocExtranjero = false; // Alfanumérico
        this.placeholderDocExtranjero = "Ingrese su documento";
        break;
      default:
        this.maxLengthDocExtranjero = 12;
        this.minLengthDocExtranjero = 6;
        this.soloDigitosDocExtranjero = false;
        this.placeholderDocExtranjero = "Ingrese su documento";
    }
  }

  /**
   * Valida caracteres permitidos para documento de extranjero.
   * Según el tipo de documento seleccionado:
   * - Carnet de Extranjería: Solo dígitos (0-9)
   * - Pasaporte: Alfanumérico (letras y números, sin caracteres especiales)
   */
  validarDocumentoExtranjero(event: any): boolean {
    const inputChar = String.fromCharCode(event.charCode);

    // Permitir teclas de control (Enter, Backspace, etc.)
    if (event.charCode === 0) {
      return true;
    }

    // Validar según tipo de documento
    if (this.soloDigitosDocExtranjero) {
      // Carnet de Extranjería: Solo números
      const pattern = /[0-9]/;
      if (!pattern.test(inputChar)) {
        event.preventDefault();
        return false;
      }
    } else {
      // Pasaporte: Letras y números (sin caracteres especiales)
      const pattern = /[a-zA-Z0-9]/;
      if (!pattern.test(inputChar)) {
        event.preventDefault();
        return false;
      }
    }
    return true;
  }

  /**
   * Valida el documento de extranjero al perder el foco (blur).
   * Muestra mensaje de error si no cumple con los requisitos.
   */
  validarDocumentoExtranjeroOnBlur(): void {
    this.errorMsgDocExtranjero = "";
    const doc = this.txtNroDocumentoExtranjero ? this.txtNroDocumentoExtranjero.toString().trim() : "";

    if (!doc) {
      return; // No validar si está vacío (se valida en el submit)
    }

    // Validar longitud mínima
    if (doc.length < this.minLengthDocExtranjero) {
      if (this.cboTipoDocumentoExtranjero === "2") {
        this.errorMsgDocExtranjero = `El Carnet de Extranjería debe tener ${this.minLengthDocExtranjero} dígitos`;
      } else {
        this.errorMsgDocExtranjero = `El documento debe tener al menos ${this.minLengthDocExtranjero} caracteres`;
      }
      return;
    }

    // Validar que solo contenga dígitos para CE
    if (this.soloDigitosDocExtranjero && !/^\d+$/.test(doc)) {
      this.errorMsgDocExtranjero = "El Carnet de Extranjería solo debe contener números";
      return;
    }

    // Validar que solo contenga alfanuméricos para Pasaporte
    if (!this.soloDigitosDocExtranjero && !/^[a-zA-Z0-9]+$/.test(doc)) {
      this.errorMsgDocExtranjero = "El Pasaporte solo debe contener letras y números";
      return;
    }
  }

  /**
   * Verifica si el documento de extranjero es válido.
   */
  isDocumentoExtranjeroValido(): boolean {
    const doc = this.txtNroDocumentoExtranjero ? this.txtNroDocumentoExtranjero.toString().trim() : "";

    if (!doc || doc.length < this.minLengthDocExtranjero) {
      return false;
    }

    if (this.soloDigitosDocExtranjero && !/^\d+$/.test(doc)) {
      return false;
    }

    if (!this.soloDigitosDocExtranjero && !/^[a-zA-Z0-9]+$/.test(doc)) {
      return false;
    }

    return true;
  }

  obtenerProvincia(codDepartamento:String){    
    this.distritoResponse.response.list = [];
    this.provincia = new UbigeoResponse();
    this.utilitarioService.loading = true;
    this.ubigeoService.obtenerProvincia(codDepartamento).subscribe(data=>{
      this.provincia = data;
      this.cboProvincia = "";
      this.cboDistrito = "";
      this.utilitarioService.loading = false;
    })
  }

  obtenerDistritos(codDepartamento:String,codProvincia:String){
    this.distritoResponse = new UbigeoResponse();
    this.utilitarioService.loading = true;
    this.ubigeoService.obtenerDistrito(codDepartamento,codProvincia).subscribe(data=>{
      this.distritoResponse = data;
      this.cboDistrito = "";
      this.utilitarioService.loading = false;
    })
  }

  onGrabarDireccion(){    
    
    if (!this.stepOneForm.valid){
      
      this.stepOneForm.markAllAsTouched();      
      return;

    }
    
    if(this.usuarioService.obtenerIDSessionUsuario()=="" || this.usuarioService.obtenerIDSessionUsuario() ==null ){ //factura
      this.utilitarioService.toastrInfo("Debe ingresar con su usuario para continuar con su compra.");
      return;
    }
    
    this.utilitarioService.loading = true;

    let direccionRequest:DireccionRequest = new DireccionRequest();
    let direccionResponse:DireccionResponse = new DireccionResponse();
    let userid = this.usuarioService.obtenerIDSessionUsuario();

    direccionRequest.cellphoneContact= this.txtCelular;
    direccionRequest.codeDepartment= this.cboDepartamentoVal;
    direccionRequest.codeDistrict= this.cboDistrito;
    direccionRequest.codeProvince= this.cboProvincia;
    direccionRequest.countryId= "12"; //codigo de pais
    direccionRequest.description= this.txtDireccion;
    direccionRequest.enabled= "";
    direccionRequest.id= "";
    direccionRequest.identifier= this.txtIdentificador;
    direccionRequest.personContact= this.txtPerContact;
    direccionRequest.reference= this.txtReferencia;
    direccionRequest.userId= userid;

    this.usuarioService.regDireccion(direccionRequest).subscribe(data=>{
      direccionResponse = data;
      if(direccionResponse.response.codeResponse="0000"){
        this.listarDireccion();
        this.flimpiarDireccion();
      }
      this.utilitarioService.loading = false;           
    });        

  }

  listarDireccion(){
    
    this.utilitarioService.loading = true;

    this.direccionUserResponse = new DireccionUserResponse();
    let userid = this.usuarioService.obtenerIDSessionUsuario();    
    
    this.usuarioService.obtenerDireccionUser(userid).subscribe(data=>{
      this.direccionUserResponse = data;
      //console.log(this.direccionUserResponse);
      //console.log("ingreso");
      this.utilitarioService.loading = false;
    })

  }

  listarTipoEntrega(){

    this.tipoEntregaBean = new RespuestaComun();    
    this.maestrasService.obtenerMaestra("TIPO_ENTREGA").subscribe(data=>{
      this.tipoEntregaBean = data;            
    })    

  }

  feliminarDireccion(direccionRequest:DireccionRequest){

    this.utilitarioService.loading = true;

    if(direccionRequest.id==this.rdbDireccionEnvio){
        this.rdbDireccionEnvio="0";
    }
    
    let direccionResponse:DireccionResponse = new DireccionResponse();
    
    direccionRequest.enabled="0";
    this.usuarioService.delDireccionUser(direccionRequest).subscribe(data=>{
      direccionResponse = data;      
      if(direccionResponse.response.codeResponse="0000"){
        this.listarDireccion();
      }
      this.utilitarioService.loading = false;
    })

  }

  flimpiarDireccion(){

    //this.divAgregarDireccion = false;
    (<HTMLButtonElement>document.getElementById("btnagregardireccion")).click();
    this.txtCelular = "";
    this.cboDepartamentoVal = "";
    this.cboDistrito= "";
    this.cboProvincia= "";  
    this.txtDireccion= ""; 
    this.txtIdentificador= "";
    this.txtPerContact= "";
    this.txtReferencia= "";

  }

  onSiguiente(){

    if (this.validarGeneral()==false){ return;}

    // Validación para Nacional (13) e Internacional (14) - mismo flujo
    if (this.cboRegionModel=="13" || this.cboRegionModel=="14"){

      if((this.rdbDireccionEnvio==null || this.rdbDireccionEnvio == "0") && this.rdbTipoEntregaVal=="11"){ //domicilio
        this.utilitarioService.toastrInfo("Seleccione o registre una dirección como mínimo.")
        return;
      }

      // console.log("this.rdbComprobante",this.rdbComprobante);
      // console.log("isPeruvian:",this.isPeruvian);

      // VALIDACIÓN PARA BOLETA
      if (this.rdbComprobante=="22") {
        // Si es extranjero, validar campos de extranjero
        if (!this.isPeruvian) {
          if (!this.cboTipoDocumentoExtranjero || this.cboTipoDocumentoExtranjero === "") {
            this.utilitarioService.toastrInfo("Debe seleccionar el tipo de documento");
            return;
          }
          if (!this.txtNroDocumentoExtranjero || this.txtNroDocumentoExtranjero.toString().trim() === "") {
            this.utilitarioService.toastrInfo("Debe ingresar el número de documento");
            return;
          }
          // Validar formato del documento según tipo
          if (!this.isDocumentoExtranjeroValido()) {
            this.validarDocumentoExtranjeroOnBlur(); // Mostrar mensaje de error
            if (this.cboTipoDocumentoExtranjero === "2") {
              this.utilitarioService.toastrInfo("El Carnet de Extranjería debe tener 9 dígitos numéricos");
            } else {
              this.utilitarioService.toastrInfo("El Pasaporte debe tener entre 6-12 caracteres (letras y números)");
            }
            return;
          }
          if (!this.txtNombreCompletoExtranjero || this.txtNombreCompletoExtranjero.toString().trim() === "") {
            this.utilitarioService.toastrInfo("Debe ingresar su nombre completo");
            return;
          }
          if (!this.cboPaisResidenciaExtranjero || this.cboPaisResidenciaExtranjero === "") {
            this.utilitarioService.toastrInfo("Debe seleccionar su país de residencia");
            return;
          }
          if (!this.txtDireccionExtranjero || this.txtDireccionExtranjero.toString().trim() === "") {
            this.utilitarioService.toastrInfo("Debe ingresar su dirección");
            return;
          }
          // Marcar como verificado para extranjeros (no requieren búsqueda)
          this.flagBuscarDniVerificado = "1";
        } else {
          // Validación para peruanos (DNI)
          if (this.flagBuscarDniVerificado=="0"){
            // Si el servicio falló pero habilitó entrada manual, validar que haya datos
            if (this.enableManualDniInput) {
              if (!this.txtFullNameModel || this.txtFullNameModel.toString().trim() === "") {
                this.utilitarioService.toastrInfo("Debe ingresar los nombres y apellidos para continuar");
                return;
              }
              // Si hay datos manuales, permitir continuar
              this.flagBuscarDniVerificado = "1";
            } else {
              this.utilitarioService.toastrInfo("Debe ingresar y buscar el número de DNI, hacer click en el boton lupa");
              return;
            }
          }
        }
      }

      // VALIDACIÓN PARA FACTURA (solo peruanos)
      if (this.rdbComprobante=="23" && this.flagBuscarRucVerificado=="0"){
        // Si el servicio falló pero habilitó entrada manual, validar que haya datos
        if (this.enableManualRucInput) {
          if (!this.txtRazonSocialModel || this.txtRazonSocialModel.toString().trim() === "") {
            this.utilitarioService.toastrInfo("Debe ingresar la razón social para continuar");
            return;
          }
          // Si hay datos manuales, permitir continuar
          this.flagBuscarRucVerificado = "1";
        } else {
          this.utilitarioService.toastrInfo("Debe ingresar y buscar el número de RUC, hacer click en el boton lupa");
          return;
        }
      }

      // VALIDACIÓN DIRECCIÓN FISCAL (solo para peruanos)
      if (this.isPeruvian) {
        if (!this.cboDepartamentoFiscal || this.cboDepartamentoFiscal === "") {
          this.utilitarioService.toastrInfo("Debe seleccionar el departamento de su dirección fiscal");
          return;
        }

        if (!this.cboProvinciaFiscal || this.cboProvinciaFiscal === "") {
          this.utilitarioService.toastrInfo("Debe seleccionar la provincia de su dirección fiscal");
          return;
        }

        if (!this.cboDistritoFiscal || this.cboDistritoFiscal === "") {
          this.utilitarioService.toastrInfo("Debe seleccionar el distrito de su dirección fiscal");
          return;
        }

        if (!this.txtDireccionFiscalDetalle || this.txtDireccionFiscalDetalle.toString().trim() === "") {
          this.utilitarioService.toastrInfo("Debe ingresar su dirección fiscal (calle, número, departamento)");
          return;
        }
      }

      if (!this.flagTerminosCondiciones){
        this.utilitarioService.toastrInfo("Debe aceptar los términos y condiciones para continuar");
        return;
      }

      if (!this.flagPoliticaPrivacidad){
        this.utilitarioService.toastrInfo("Debe aceptar la política de privacidad para continuar");
        return;
      }

      this.onEnviarOrder();
      this.cdkStepOne.completed = true; //colca a completado para porder avanzar al sgt step
      this.cdkStepper.next();
      this.cdkStepOne.completed = false; //coloca el step uno a incompleta para desabilidatr tecla left rigth cuando retorne
      //console.log(this.orderRequest);

    }

  }

  validarGeneral() : Boolean{
    //valida que exista uno libro seleccionado
    this.carritoService.verificarCarritoSelecionados();
    //valida formulario
    if(this.usuarioService.obtenerIDSessionUsuario()=="" || this.usuarioService.obtenerIDSessionUsuario() ==null ){ //factura
      this.utilitarioService.toastrInfo("Debe ingresar con su usuario para continuar con su compra.");
      return false;
    }

    return true;

  }

  onSolicitarCotizacion(){

    if (this.validarGeneral()==false){ return;}
      
      //valida internacional
    if (this.cboRegionModel=="14"){
        
      if(this.cboPaisModel==""){
          this.utilitarioService.toastrInfo("Seleccione el país a enviar.");
          return;
      }
    
      if(this.txtDireccionInternacional==""){
          this.utilitarioService.toastrInfo("Ingrese la dirección del país.");
          return;
      }

      //envia correo electronico      
      this.enviarOrdenInternacional();      
    }
  }

  async enviarOrdenInternacional(){        

    this.carritoDetalle = new CarritoHeader();
    this.carritoDetalle=this.carritoService.obtenerCarritoCompras();
    let orderInternacionalRequest = new OrderInternacionalRequest();    
    let listDetailBook = new Array<DetailBook>();

    this.SubTotalTemp = 0;
    this.IGVDelivery = 0;
    this.IGVProducto = 0;
    this.IGVTotal = 0;



    this.utilitarioService.loading=true;
    //obtiene nuevamente costos con BD por seguridad
    for (let i = 0; i < this.carritoDetalle.lista.length; i++) {
        
        let libroDetalleTemp=new LibroDetalle();
        let libroSourvenirTemp=new SourvenirDetalleResponse();

        //recorre carrito en temporal con bd para obtener costos y detalle del producto uno por uno
        // var libroDetalle:LibroDetalle = await this.novedadesService.obtenerDetalleLibroAsync(this.carritoDetalle.lista[i].id).toPromise();                
        // libroDetalleTemp = libroDetalle;      
        // this.precioTotal = Number((this.precioTotal + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(libroDetalleTemp.response.list[0].price))).toFixed(2));
        // this.cantidadTotal = this.cantidadTotal + Number(this.carritoDetalle.lista[i].cantidad);        
        
        if(this.carritoDetalle.lista[i].tipoProducto=="1"){
          // Enviar userId para determinar nacionalidad por tipo de documento
          const userIdEnvio = this.usuarioService.obtenerIDSessionUsuario();
          var libroDetalle:LibroDetalle = await this.novedadesService.obtenerDetalleLibroAsync(this.carritoDetalle.lista[i].id, userIdEnvio).toPromise();
          libroDetalleTemp = libroDetalle;      
          
          
          let precio = libroDetalleTemp.response.list[0].modalidades.find(data=>
            data.id==this.carritoDetalle.lista[i].modalidadId
          ).price;

          this.precioTotal = Number((this.precioTotal + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(precio))).toFixed(2));
          this.cantidadTotal = this.cantidadTotal + Number(this.carritoDetalle.lista[i].cantidad);  

          this.SubTotalTemp = Number((this.SubTotalTemp + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(libroDetalleTemp.response.list[0].price))).toFixed(2));

        }
        else if(this.carritoDetalle.lista[i].tipoProducto=="2"){
          var sourvenirDetalle:SourvenirDetalleResponse = await this.novedadesService.obtenerDetalleSourvenirAsync(this.carritoDetalle.lista[i].id).toPromise();                
          libroSourvenirTemp = sourvenirDetalle;      
          this.precioTotal = Number((this.precioTotal + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(libroSourvenirTemp.response.list[0].price))).toFixed(2));
          this.cantidadTotal = this.cantidadTotal + Number(this.carritoDetalle.lista[i].cantidad);  

          let tempPrecioSinIGV = 0;
            //tempPrecioSinIGV = Number(libroSourvenirTemp.response.list[0].price) - ( Number(libroSourvenirTemp.response.list[0].price) * 0.18);
            tempPrecioSinIGV =  Number((Number(libroSourvenirTemp.response.list[0].price) / 1.18).toFixed(2));

            
            //this.IGVProducto = this.IGVProducto + (Number(libroSourvenirTemp.response.list[0].price) * 0.18);
            //this.IGVProducto = this.IGVProducto + ((Number(libroSourvenirTemp.response.list[0].price) * 0.18)*Number(this.carritoDetalle.lista[i].cantidad));


           // this.IGVProducto = this.IGVProducto + (Number((Number((Number(libroSourvenirTemp.response.list[0].price) / 1.18).toFixed(2)) * 0.18).toFixed(2))*Number(this.carritoDetalle.lista[i].cantidad));
           this.IGVProducto = this.IGVProducto +  (Number(libroSourvenirTemp.response.list[0].price) - tempPrecioSinIGV ) * Number(this.carritoDetalle.lista[i].cantidad);


            this.SubTotalTemp = Number((this.SubTotalTemp + ( Number(this.carritoDetalle.lista[i].cantidad) * tempPrecioSinIGV)).toFixed(2));
  
        }

    }

    for (let i = 0; i < this.carritoDetalle.lista.length; i++) {
      let detailBook = new DetailBook();
      //detailBook.bookId = this.carritoDetalle.lista[i].id;
      detailBook.quantity = this.carritoDetalle.lista[i].cantidad;

      if(this.carritoDetalle.lista[i].tipoProducto=="1"){
        detailBook.bookId = this.carritoDetalle.lista[i].id;
        detailBook.productId = "0";
        detailBook.sizeId = this.carritoDetalle.lista[i].sizeID;

      }
      else if(this.carritoDetalle.lista[i].tipoProducto=="2"){
        detailBook.productId = this.carritoDetalle.lista[i].id;
        detailBook.bookId ="0";
        detailBook.sizeId = this.carritoDetalle.lista[i].sizeID;
      }




      listDetailBook.push(detailBook);
    }
    this.IGVTotal = this.IGVProducto + this.IGVDelivery;


    orderInternacionalRequest.clientId = this.usuarioService.obtenerIDSessionUsuario();
    orderInternacionalRequest.countryAddress = this.txtDireccionInternacional.toString();
    orderInternacionalRequest.countryId = this.cboPaisModel.toString();
    orderInternacionalRequest.detailBookAndProduct = listDetailBook;
    //orderInternacionalRequest.igvCost = "0";
    orderInternacionalRequest.igvCost = this.IGVTotal.toFixed(2).toString();
    orderInternacionalRequest.subtotalCost = this.SubTotalTemp.toString();


    orderInternacionalRequest.shippingCost = "0";
    //orderInternacionalRequest.subtotalCost = this.precioTotal.toString();
    orderInternacionalRequest.totalCost = this.precioTotal.toString();
    // console.log("orderInternacionalRequest",orderInternacionalRequest);
    this.procesarPagoService.grabarOrdenInternacional(orderInternacionalRequest).subscribe(data=>{
      //console.log(data);
      if (data.response.codeResponse=="0000"){        
        this.router.navigate(['/respuestainternacional', data.response.list[0].orderId]);
        this.utilitarioService.toastrSuccess("Se ha enviado su orden via correo electronico");
        this.carritoService.limpiarCarrito();
      }else{
        this.utilitarioService.toastrSuccess(data.response.response);
      }
      this.utilitarioService.loading=false;
    });

  }

  onBuscarDni(){

    if(this.txtDNIModel.length==0){
        this.utilitarioService.toastrInfo("Ingrese número de DNI");
        return;
    }

    this.isLoadingDni = true;

    //let formDataPersonaBus = new FormData();
    // formDataPersonaBus.append("P_NRO_DOCUMENTO",this.txtDNIModel.toString());
    // formDataPersonaBus.append("P_DOCUMENTO_IDENTIDAD","1");
    // formDataPersonaBus.append("P_CREDENCIALES", JSON.stringify({credencialesbean:this.externosService.getCredencialesGestionUsuario()}));
    
this.externosService.obtenerDatosXML(this.txtDNIModel.toString())
  .pipe(
    catchError(err => {
      this.isLoadingDni = false;
      // Solo habilitar entrada manual si hay error de servicio (no 200)
      this.enableManualDniInput = true;

      // El servicio está caído o no responde - permitir entrada manual
      if (err.status === 500 || err.status === 503 || err.status === 0) {
        this.utilitarioService.toastrInfo("El servicio de validación no está disponible temporalmente. Puede ingresar los datos manualmente para continuar.");
      } else if (err.status === 404) {
        this.utilitarioService.toastrInfo("Servicio de validación no encontrado. Puede ingresar los datos manualmente para continuar.");
      } else {
        this.utilitarioService.toastrInfo("No se pudo conectar con el servicio de validación. Puede ingresar los datos manualmente para continuar.");
      }

      console.error("Error en obtenerDatosXML:", err);
      this.flagBuscarDniVerificado = "0";
      this.txtFullNameModel = "";
      return of(null); // Retorna valor vacío para que el flujo no se rompa
    })
  )
  .subscribe(data => {
    if (!data) return; // Si hubo error ya se manejó arriba
    let obj = JSON.parse(data);

    // Respuesta 200 exitosa con datos
    if (obj.Result != null && obj.Result !== "null") {
      this.txtFullNameModel = `${obj.Result.Nombres} ${obj.Result.ApellidoPaterno} ${obj.Result.ApellidoMaterno}`;
      this.txtPersonaNombres = obj.Result.Nombres;
      this.txtPersonaApellidoPaterno = obj.Result.ApellidoPaterno;
      this.txtPersonaApellidoMaterno = obj.Result.ApellidoMaterno;
      this.flagBuscarDniVerificado = "1";
      this.enableManualDniInput = false;
    } else {
      // Verificar si es un error del servicio (Response = "W") o DNI no encontrado
      if (obj.Response === "W" || obj.Message) {
        // Error del servicio (conexion, permisos, etc.) - permitir entrada manual
        console.error("Error del servicio RENIEC:", obj.Message);
        this.utilitarioService.toastrInfo("El servicio de validación no está disponible temporalmente. Puede ingresar los datos manualmente para continuar.");
        this.flagBuscarDniVerificado = "0";
        this.enableManualDniInput = true;
        this.txtFullNameModel = "";
      } else {
        // Respuesta 200 pero sin datos - DNI incorrecto, NO permitir entrada manual
        this.utilitarioService.toastrError("No se encontró información para el DNI ingresado. Verifique el número e intente nuevamente.");
        this.flagBuscarDniVerificado = "0";
        this.enableManualDniInput = false;
        this.txtFullNameModel = "";
      }
    }
    this.isLoadingDni = false;
  });
    // this.externosService.busDocumentoIdentidad(formDataPersonaBus).subscribe((personaBeanM : PersonaBeanM) =>{
    //   console.log(personaBeanM);

    //   switch(personaBeanM.mensajeResponseBeanM.codigoservicerespuesta) { 
    //     case "0001": {
    //       console.log(personaBeanM);
    //       this.flagBuscarDniVerificado = "1";
    //       this.txtFullNameModel = personaBeanM.nombres + " " + personaBeanM.apepaterno + " " + personaBeanM.apematerno;
    //       this.txtPersonaNombres = personaBeanM.nombres;
    //       this.txtPersonaApellidoPaterno= personaBeanM.apepaterno;
    //       this.txtPersonaApellidoMaterno = personaBeanM.apematerno;
    //       break;

    //     } 
    //     case "0000": { 
    //       this.utilitarioService.toastrError("Ocurrio un error en el servicio.");
    //       console.log(personaBeanM);
    //       this.flagBuscarDniVerificado = "0";
    //       this.txtFullNameModel = "";
    //       this.txtPersonaNombres = "";
    //       this.txtPersonaApellidoPaterno= "";
    //       this.txtPersonaApellidoMaterno = "";
    //       break; 
    //     }
    //     default: { 
    //       this.utilitarioService.toastrInfo(personaBeanM.mensajeResponseBeanM.descripcion);
    //       this.flagBuscarDniVerificado = "0";
    //       this.txtFullNameModel = "";
    //       this.txtPersonaNombres = "";
    //       this.txtPersonaApellidoPaterno= "";
    //       this.txtPersonaApellidoMaterno = "";
    //       break; 
    //     }
    //   }
      
    //   this.txtRazonSocialModel = "";
    //   this.utilitarioService.loading=false;

    // });

  }
  
  onBuscarRUC(){

    if(this.txtRucModel.length==0){
      this.utilitarioService.toastrInfo("Ingrese número de RUC");
      return;
    }

    this.isLoadingRuc = true;
  
this.externosService.obtenerDatosRUCXML(this.txtRucModel.toString()).subscribe({
  next: data => {
    // console.log("data", data);
    let obj = JSON.parse(data);

    // Respuesta 200 exitosa con datos
    if (obj.Result != null && obj.Result !== "null") {
      this.flagBuscarRucVerificado = "1";
      this.txtRazonSocialModel = obj.Result.RazonSocial;
      this.enableManualRucInput = false;
    } else {
      // Verificar si es un error del servicio (Response = "W") o RUC no encontrado
      if (obj.Response === "W" || obj.Message) {
        // Error del servicio (conexion, permisos, etc.) - permitir entrada manual
        console.error("Error del servicio SUNAT:", obj.Message);
        this.utilitarioService.toastrInfo("El servicio de validación no está disponible temporalmente. Puede ingresar los datos manualmente para continuar.");
        this.flagBuscarRucVerificado = "0";
        this.txtRazonSocialModel = "";
        this.enableManualRucInput = true;
      } else {
        // Respuesta 200 pero sin datos - RUC incorrecto, NO permitir entrada manual
        this.utilitarioService.toastrError("No se encontró información para el RUC ingresado. Verifique el número e intente nuevamente.");
        this.flagBuscarRucVerificado = "0";
        this.txtRazonSocialModel = "";
        this.enableManualRucInput = false;
      }
    }

    // Limpiar datos de persona
    this.txtPersonaNombres = "";
    this.txtPersonaApellidoPaterno = "";
    this.txtPersonaApellidoMaterno = "";

    this.isLoadingRuc = false;
  },
  error: err => {
    this.isLoadingRuc = false;
    // Solo habilitar entrada manual si hay error de servicio (no 200)
    this.enableManualRucInput = true;

    // El servicio está caído o no responde - permitir entrada manual
    if (err.status === 500 || err.status === 503 || err.status === 0) {
      this.utilitarioService.toastrInfo("El servicio de validación no está disponible temporalmente. Puede ingresar los datos manualmente para continuar.");
    } else if (err.status === 404) {
      this.utilitarioService.toastrInfo("Servicio de validación no encontrado. Puede ingresar los datos manualmente para continuar.");
    } else {
      this.utilitarioService.toastrInfo("No se pudo conectar con el servicio de validación. Puede ingresar los datos manualmente para continuar.");
    }

    console.error("Error en obtenerDatosRUCXML:", err);
    this.flagBuscarRucVerificado = "0";
    this.txtRazonSocialModel = "";

    // Limpiar datos de persona
    this.txtPersonaNombres = "";
    this.txtPersonaApellidoPaterno = "";
    this.txtPersonaApellidoMaterno = "";
  }
});

 

    // let formDataRucBus = new FormData();
    // formDataRucBus.append("P_RUC",this.txtRucModel.toString());
    // formDataRucBus.append("P_CREDENCIALES", JSON.stringify({credencialesbean:this.externosService.getCredencialesGestionUsuario()}));

    // this.externosService.busDocumentoRuc(formDataRucBus).subscribe((rucEntidadBeanMResponse : RucEntidadBeanMResponse) => {
      
    //   console.log(rucEntidadBeanMResponse);
    //       switch(rucEntidadBeanMResponse.mensajeResponseBeanM.codigoservicerespuesta) { 
    //         case "0001": {              
    //           this.flagBuscarRucVerificado = "1";
    //           this.txtRazonSocialModel = rucEntidadBeanMResponse.x_razonsocial;
    //           break;

    //         }
    //         case "0000": { 
    //           this.utilitarioService.toastrError("Ocurrio un error en el servicio.");
    //           this.flagBuscarRucVerificado = "0";
    //           this.txtRazonSocialModel = "";
    //           break;

    //         }
    //         default: { 
    //           this.utilitarioService.toastrInfo(rucEntidadBeanMResponse.mensajeResponseBeanM.descripcion);
    //           this.flagBuscarRucVerificado = "0";
    //           this.txtRazonSocialModel = "";
    //           break;  

    //         }
    //       }

    //       this.txtPersonaNombres = "";
    //       this.txtPersonaApellidoPaterno= "";
    //       this.txtPersonaApellidoMaterno = "";

    //       this.utilitarioService.loading=false;

    // });

  }
  activarFlag(){
    this.flagTerminosCondiciones=this.flagTerminosCondiciones?false:true;
  }

  onClickCheckboxTerminos(){
    // Cuando el usuario hace clic en el checkbox, siempre abre el modal
    this.abrirModalTerminos();
  }

  onClickLinkTerminos(){
    // Cuando el usuario hace clic en el link de "Términos y Condiciones"
    // Solo abre el modal para leer, sin afectar el estado del checkbox
    this.abrirModalTerminos();
  }

  abrirModalTerminos(){
    this.abrirModalTerminosEvent.emit();
  }

  cerrarModalTerminos(){
    // Cuando cierra el modal (botón cerrar o X), se desmarca el checkbox
    // Esto significa que el usuario no acepta o retira su aceptación
    this.flagTerminosCondiciones = false;
    this.cerrarModalTerminosEvent.emit();
  }

  aceptarTerminos(){
    // Solo aquí se marca el checkbox, cuando el usuario acepta en el modal
    this.flagTerminosCondiciones = true;
    this.aceptarTerminosEvent.emit();
  }

  // Métodos para Política de Privacidad
  onClickCheckboxPoliticaPrivacidad(){
    // Toggle del checkbox
    this.flagPoliticaPrivacidad = !this.flagPoliticaPrivacidad;
  }

  onClickLinkPoliticaPrivacidad(){
    // Solo abrir el enlace sin cambiar el estado del checkbox
    window.open('https://www.editoraperu.com.pe/PrivacidadEP/Politica_Proteccion_Datos_Personales.pdf', '_blank');
  }

  // Método para checkbox único de Términos y Política de Privacidad
  onClickCheckboxTerminosYPolitica(){
    // Toggle de ambas banderas juntas
    const nuevoEstado = !(this.flagTerminosCondiciones && this.flagPoliticaPrivacidad);
    this.flagTerminosCondiciones = nuevoEstado;
    this.flagPoliticaPrivacidad = nuevoEstado;
  }

  get isFormularioValido(): boolean {
    // Validar términos y condiciones
    if (!this.flagTerminosCondiciones) {
      return false;
    }

    // Validar política de privacidad
    if (!this.flagPoliticaPrivacidad) {
      return false;
    }

    // Validar comprobante boleta
    if (this.rdbComprobante === "22") {
      // Si es EXTRANJERO, validar campos de extranjero
      if (!this.isPeruvian) {
        // Tipo de documento seleccionado
        if (!this.cboTipoDocumentoExtranjero || this.cboTipoDocumentoExtranjero === "") {
          return false;
        }
        // Número de documento con formato válido
        if (!this.txtNroDocumentoExtranjero || this.txtNroDocumentoExtranjero.toString().trim() === "") {
          return false;
        }
        // Validar formato del documento según tipo (CE: 9 dígitos, Pasaporte: 6-12 alfanumérico)
        if (!this.isDocumentoExtranjeroValido()) {
          return false;
        }
        // Nombre completo
        if (!this.txtNombreCompletoExtranjero || this.txtNombreCompletoExtranjero.toString().trim() === "") {
          return false;
        }
        // País de residencia
        if (!this.cboPaisResidenciaExtranjero || this.cboPaisResidenciaExtranjero === "") {
          return false;
        }
        // Dirección
        if (!this.txtDireccionExtranjero || this.txtDireccionExtranjero.toString().trim() === "") {
          return false;
        }
        return true;
      } else {
        // Si es PERUANO y el DNI no está verificado
        if (this.flagBuscarDniVerificado === "0") {
          // Permitir si está habilitado el modo manual Y hay datos ingresados
          if (this.enableManualDniInput && this.txtFullNameModel && this.txtFullNameModel.toString().trim() !== "") {
            return true;
          }
          return false;
        }
      }
    }

    // Validar comprobante factura (RUC) - solo para peruanos
    if (this.rdbComprobante === "23") {
      // Si el RUC no está verificado
      if (this.flagBuscarRucVerificado === "0") {
        // Permitir si está habilitado el modo manual Y hay datos ingresados
        if (this.enableManualRucInput && this.txtRazonSocialModel && this.txtRazonSocialModel.toString().trim() !== "") {
          return true;
        }
        return false;
      }
    }

    return true;
  }

}
